var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1045.77 455.53",
    width: 1045.77,
    height: 455.53,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#040405;fill-rule:evenodd;}")), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.23,
    y: 311.79999,
    width: 1045.77,
    height: 455.53,
    id: "rect4",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_197",
    "data-name": "Grupo 197",
    transform: "translate(-152.23,-311.79999)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2",
    clipPath: "url(#clip-path)",
    id: "g11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_196",
    "data-name": "Grupo 196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_270",
    "data-name": "Trazado 270",
    className: "cls-3",
    d: "m 1198,767.35 a 238.65,238.65 0 0 1 -23.2,-57.19 L 1063.3,354.5 a 204,204 0 0 1 -7.47,-42.68 h -86.62 a 91.17,91.17 0 0 1 -12.86,28.53 c -4.15,5.4 -8.29,10.36 -12,16.17 l -147.17,192.34 -17.82,-56.38 96.56,-128.06 -56,71.75 -69.92,89.43 -32.13,41.23 -10.54,13.5 21.45,60.24 -31.94,41.87 -19.88,-63 2.39,-3.27 -32.08,41.08 -84.6,108.33 -1.43,1.82 h 3 L 608.13,711 626,767.4 h 83.4 l 41.45,-56.78 17,56.78 H 871.4 a 451.25,451.25 0 0 1 -22.8,-56.78 l -29.43,-88.7 32.74,-43.1 h 182.37 l 41,131 a 291.76,291.76 0 0 1 13.17,57.61 h 109.42 z m -301.74,-245 82.48,-114.82 37.72,114.82 z m -65.83,-210.53 -0.31,0.75 A 249.61,249.61 0 0 1 799.74,357 l -45.66,60.6 -1,-3 -18.52,-57.06 c -1.06,-3.44 -2,-6.8 -2.9,-10.16 -3,-11.23 -5.22,-22.36 -7.46,-35.44 H 618.12 a 266.06,266.06 0 0 1 17.42,43.12 l 27.39,83.55 21.84,66.61 0.92,2.78 -31.56,41.29 -0.81,-2.62 -21.42,-67.12 -39.11,-122.61 a 145.64,145.64 0 0 1 -7,-45.19 h -87.47 a 94.59,94.59 0 0 1 -12,29.43 120,120 0 0 1 -9.94,15.37 L 206.94,712.62 a 308.29,308.29 0 0 1 -54.71,54.71 h 88.29 L 382.7,578.73 h 182 l 19.6,59.56 1.14,3.44 -53.07,69.66 A 361.6,361.6 0 0 1 501.48,748 c -4.59,4.67 -9.62,9.46 -15.17,14.35 a 59,59 0 0 1 -5.38,5 h 10.41 L 503.8,750.83 834.62,311.89 Z m -406.29,210.55 86.64,-114.82 37.73,114.82 z",
    style: {
      fill: "#040405",
      fillRule: "evenodd"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxa);
export default __webpack_public_path__ + "static/media/axa.1f627948099c445d6ae01b9e9f0aa024.svg";
export { ForwardRef as ReactComponent };